import {Observable} from "rxjs";
import {CustomStoreFinderSearchPage} from "../models/store-finder.model";

export abstract class CustomStoreFinderAdapter {
  abstract search(): Observable<CustomStoreFinderSearchPage>;
}
